var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"btn-blue",attrs:{"disabled":_vm.disabled}},_vm.$listeners),[_c('span',[_vm._v(_vm._s(_vm.$t('general.next')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }